/**
 * Permission helpers
 * Client-side permission evaluation for UI rendering decisions.
 * NOTE: These do NOT replace server-side RLS. They are for UX only.
 */

import type { AppRole } from '@/config/constants';
import { ROLES } from '@/config/constants';

export function isAdmin(role: AppRole | null): boolean {
  return role === ROLES.ADMIN;
}

export function isEmployee(role: AppRole | null): boolean {
  return role === ROLES.EMPLOYEE;
}

export function canManageEmployees(role: AppRole | null): boolean {
  return isAdmin(role);
}

export function canManageContracts(role: AppRole | null): boolean {
  return isAdmin(role);
}

export function canManageDocuments(role: AppRole | null): boolean {
  return isAdmin(role);
}

export function canViewAuditLog(role: AppRole | null): boolean {
  return isAdmin(role);
}

export function canInviteEmployees(role: AppRole | null): boolean {
  return isAdmin(role);
}

export function canManageTenants(role: AppRole | null): boolean {
  return isAdmin(role);
}

export function canReviewItems(role: AppRole | null): boolean {
  return isAdmin(role);
}

export function canUploadOwnDocuments(role: AppRole | null): boolean {
  return role === ROLES.EMPLOYEE || role === ROLES.ADMIN;
}

export function canViewOwnAttendance(role: AppRole | null): boolean {
  return role === ROLES.EMPLOYEE || role === ROLES.ADMIN;
}
